import * as React from 'react'
import { Spinner } from '$views/components/Spinner/Spinner'
import { Notification } from '$views/components/Notification'
import { Error } from '$views/components/Error'
import { Block } from '$views/components/Layout/Block'
import { LoginForm } from '$views/components/LoginForm'
import { Division } from '$views/components/Division'
import { Link } from '$views/components/Link'
import { Text } from '$views/components/Text'
import { routeProvider } from '$utils/routeProvider'
import { ErrorView } from '$views/components/Error/Error.model'

interface LoginFormValues {
  email: string
  password: string
}

interface Props {
  onSubmit: (loginCuidador: LoginFormValues) => void
  isLoading: boolean
  notification?: string
  showNotification: boolean
  onNotificationClick: () => void
  errorNotification?: ErrorView
  showErrorNotification: boolean
  onErrorNotificationClick: () => void
  fluid?: boolean
}

export const LoginWindow: React.SFC<Props> = ({
  errorNotification,
  isLoading,
  notification,
  onErrorNotificationClick,
  onNotificationClick,
  onSubmit,
  showErrorNotification,
  showNotification,
  fluid,
}) => (
  <>
    {isLoading && <Spinner />}
    {showNotification && (
      <Notification
        text={notification}
        buttonLabel={'Aceptar'}
        onClick={onNotificationClick}
        title={'Validando datos'}
      />
    )}
    {showErrorNotification && <Error error={errorNotification} onClick={onErrorNotificationClick} />}
    <Text title marginTop="mini">
      Iniciar sesión
    </Text>
    <Block marginTop="mini">
      <LoginForm onSubmit={onSubmit} fluid={fluid} />
    </Block>
    <Block marginTop="mini">
      <Text menu>
        <Link href={routeProvider.resetPassword}>¿Has olvidado tu contraseña?</Link>
      </Text>
    </Block>
    <Division marginTop="small" color="lightGrey" />
    <Block marginTop="mini">
      <Text>¿No tienes una cuenta?</Text>
      <Text marginTop="base">
        <Link href={routeProvider.customerRegistration}>Regístrate como familia</Link>
      </Text>
      <Text marginTop="base">
        <Link href={routeProvider.caretakerRegistration}>Regístrate como profesional</Link>
      </Text>
    </Block>
  </>
)



// WEBPACK FOOTER //
// ./src/views/Login/components/LoginWindow.tsx